import {
  LOGIN_EMAIL,
  VERIFY_CODE,
  LOGIN_ERROR,
  OTP_SEND,
  CODE_VERIFIED,
  CODE_VERIFICATION_ERROR,
  RESET_USER,
  SELF_LOGIN_ERROR,
  SELF_LOGIN,
  SET_APP_VERSION,
} from './types';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_EMAIL:
      return {
        ...state,
        loading: true,
        error: null,
        data: action.payload,
      };
    case OTP_SEND: {
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    case SELF_LOGIN: {
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    case SELF_LOGIN_ERROR:
    case LOGIN_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {},
      };
    }
    case VERIFY_CODE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CODE_VERIFIED: {
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    case CODE_VERIFICATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case RESET_USER: {
      return {
        ...initialState,
        appVersion: state.appVersion,
      };
    }

    case SET_APP_VERSION: {
      return {
        ...state,
        appVersion: action.payload,
      };
    }
    default:
      return state;
  }
}
